(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner-meta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-banner__heading').forEach(el => {
    el.textContent = el.textContent
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        // const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isLargeScreen = window.matchMedia('(min-width: 768px)').matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  document.querySelectorAll('.collection-banner__heading').forEach(el => {
    el.textContent = el.textContent
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('on:cart:add',(event)=>{if(window.matchMedia("(max-width: 1023px)").matches){showCartNotification("Product was added to your cart!");}});document.addEventListener('on:line-item:change',(event)=>{if(window.matchMedia("(max-width: 1023px)").matches){showCartNotification("Cart updated!");}});function showCartNotification(message){const mainContent=document.getElementById('main-content');if(!mainContent){console.error('Element with ID "main-content" not found.');return;}let popup=document.querySelector('.custom-quick-add__alert');if(!popup){popup=document.createElement('div');popup.className='custom-quick-add__alert';popup.innerHTML=`<div class="alert quick-add__alert absolute left-0 right-0 bg-success-bg text-success-text p-4"><span class="quick-add__message">${message}</span></div>`;mainContent.appendChild(popup);}popup.querySelector('.quick-add__message').textContent=message;popup.hidden=false;setTimeout(()=>{popup.hidden=true;},3000);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-subcollections"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-columns-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 4.2,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });
        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
window.TrustpilotLoader=window.TrustpilotLoader||{initialized:false,widgets:new Map(),init:function(){if(this.initialized)return;this.initialized=true;this.waitForTrustpilot(()=>{this.scanAndInitialize();this.setupObservers()})},waitForTrustpilot:function(callback,attempts=0){if(typeof window.Trustpilot!=='undefined'&&window.Trustpilot.loadFromElement){callback()}else if(attempts<100){setTimeout(()=>this.waitForTrustpilot(callback,attempts+1),100)}},scanAndInitialize:function(){const containers=document.querySelectorAll('.trustpilot-container');containers.forEach(container=>this.initializeWidget(container))},initializeWidget:function(container){if(!container||this.widgets.has(container.id))return;const templateId=container.dataset.templateId;const businessunitId=container.dataset.businessunitId;const locale=container.dataset.locale||'en-GB';const widget=document.createElement('div');widget.className='trustpilot-widget';widget.setAttribute('data-locale',locale);widget.setAttribute('data-template-id',templateId);widget.setAttribute('data-businessunit-id',businessunitId);widget.setAttribute('data-style-height','24px');widget.setAttribute('data-style-width','100%');widget.innerHTML='<a href="https://uk.trustpilot.com/review/ecigone.co.uk" target="_blank" rel="noopener">Trustpilot</a>';container.innerHTML='';container.appendChild(widget);try{window.Trustpilot.loadFromElement(widget);this.widgets.set(container.id,{container:container,widget:widget,initialized:true})}catch(error){}},reinitializeAll:function(){this.widgets.clear();setTimeout(()=>{this.scanAndInitialize()},100)},setupObservers:function(){const observer=new MutationObserver((mutations)=>{let hasNewContainers=false;mutations.forEach((mutation)=>{mutation.addedNodes.forEach((node)=>{if(node.nodeType===1){const containers=node.classList?.contains('trustpilot-container')?[node]:(node.querySelectorAll?.('.trustpilot-container')||[]);if(containers.length>0){hasNewContainers=true}}})});if(hasNewContainers){setTimeout(()=>this.scanAndInitialize(),200)}});observer.observe(document.body,{childList:true,subtree:true})}};document.addEventListener('DOMContentLoaded',function(){let blazeInstances=[];function initBlazeSliders(target=document){blazeInstances.forEach(instance=>{if(instance&&typeof instance.destroy==='function'){try{instance.destroy()}catch(e){}}});blazeInstances=[];target.querySelectorAll('.promo-slider').forEach((el)=>{const blazeInstance=new BlazeSlider(el,{all:{slidesToShow:4,slidesToScroll:1,enableAutoplay:true,loop:true,draggable:true,autoplayDirection:'to left'},'(max-width: 1440px)':{slidesToShow:3},'(max-width: 1024px)':{slidesToShow:2},'(max-width: 768px)':{slidesToShow:1,autoplayInterval:3000}});blazeInstances.push(blazeInstance);setTimeout(()=>{window.TrustpilotLoader.reinitializeAll()},500);blazeInstance.onSlide(()=>{setTimeout(()=>{window.TrustpilotLoader.scanAndInitialize()},100)})})}setTimeout(()=>{window.TrustpilotLoader.init();initBlazeSliders()},100);document.addEventListener('shopify:section:load',function(event){setTimeout(()=>{initBlazeSliders(event.target)},200)});let resizeTimer;window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(()=>{window.TrustpilotLoader.scanAndInitialize()},300)})});

  } catch(e) { console.error(e); }
})();
})();
